module.exports = __webpack_public_path__ + "static/media/robertMarion26.b915f96e.png";